module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAZCAYAAADaILXQAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuMTnU1rJkAAAA1klEQVRIS8WUQQrDIBBFA9113WN03WVv00v0ArmLZxH0RtYvjhjR0SFM+mBkhO+rGZJu788etEpfvkVCCGyBcmghf5BHvnS4V865F/WzvFiOQN1HdOTW2juXP8iNMTccHoGRdMYy5LqxYMOFUQhQj6dQk6OPiORD8k1b+ZCefPnm8W15YM+RzmCRytHPSLkqrCov0IxB/Q2ckf9vLHgC6nOeJeWq8DUzb5G+56CVszeX/HFRdlmOQN3PSDks0o/Ie//EniOdwZLlU0iOfvYDRa5VivI9/AD5fDt0FT6OjAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/slide-tray-workflow/workflow-icon.png
// module id = 335
// module chunks = 0